import type { DraftContext } from '@/features/coach-review/composerDrafts';
import { resolveCurrentFeedbackParent } from './resolveSavedPrivateFeedback';

/** The selected identity is a navigation intent, never a grant or a write CAS. */
export type FeedbackFocusRequest = Readonly<{ owner: DraftContext; feedbackId: string }>;

export function resolveFeedbackFocus(request: FeedbackFocusRequest, signal: AbortSignal) {
  return resolveCurrentFeedbackParent(request.owner, request.feedbackId, signal, true);
}
